const DISMISS_KEY_PREFIX = 'walkthrough:dismissed:';

// Strict null check: an undefined field means the user payload predates the
// walkthrough, and showing it then would reopen it on every load.
export const shouldShowWalkthrough = (user, canAsk) =>
  Boolean(user) && canAsk === true && user.walkthrough_seen_at === null;

export const isWalkthroughDismissedThisSession = (userId) => {
  try {
    return window.sessionStorage.getItem(`${DISMISS_KEY_PREFIX}${userId}`) === '1';
  } catch (_) {
    return false;
  }
};

export const markWalkthroughDismissedThisSession = (userId) => {
  try {
    window.sessionStorage.setItem(`${DISMISS_KEY_PREFIX}${userId}`, '1');
  } catch (_) {
    // Storage unavailable (private mode, quota): the guard lasts until remount.
  }
};
